import { DeliveryMethod } from "../../../state/types"
import { DeliveryOrderList } from "../delivery-order-list/deliveryOrderList"

export const ReceptionOrderList = () => {
    return <DeliveryOrderList method={DeliveryMethod.RECEPTION} />
}
